
/**
 * Utility for triggering onboarding related events
 */

export const triggerLisaChat = () => {
  try {
    const chatButton = document.querySelector('.chat-button') as HTMLButtonElement;
    if (chatButton) {
      chatButton.click();
    } else {
      console.log('Chat button not found');
    }
  } catch (error) {
    console.error('Error triggering Lisa chat:', error);
  }
};

export const triggerOnboardingStep = (stepId: string) => {
  try {
    window.dispatchEvent(new CustomEvent('onboarding-step-trigger', {
      detail: { stepId }
    }));
  } catch (error) {
    console.error('Error triggering onboarding step:', error);
  }
};

export const markStepCompleted = (stepId: string) => {
  try {
    window.dispatchEvent(new CustomEvent('onboarding-step-completed', {
      detail: { stepId }
    }));
  } catch (error) {
    console.error('Error marking step as completed:', error);
  }
};

// Function to control checklist visibility
export const setChecklistVisibility = (isOpen: boolean) => {
  try {
    // Save state in sessionStorage to maintain it during navigation
    sessionStorage.setItem('onboarding-checklist-open', isOpen ? 'true' : 'false');
    
    // Dispatch event so other components can react
    window.dispatchEvent(new CustomEvent('onboarding-visibility-changed', {
      detail: { isOpen }
    }));
    
    console.log(`[ONBOARDING] Checklist visibility set to: ${isOpen}`);
    
    // If we're opening the checklist, increment the day number
    if (isOpen) {
      incrementDayNumber();
    }
  } catch (error) {
    console.error('Error setting checklist visibility:', error);
  }
};

// Get current visibility state
export const getChecklistVisibility = (): boolean => {
  try {
    const value = sessionStorage.getItem('onboarding-checklist-open');
    // Only return true if explicitly saved as 'true'
    return value === 'true';
  } catch (error) {
    console.error('Error getting checklist visibility:', error);
    return false;
  }
};

// Increment day number
export const incrementDayNumber = () => {
  try {
    const currentDay = localStorage.getItem('onboarding-day-number');
    const dayNumber = currentDay ? parseInt(currentDay, 10) : 0;
    const nextDay = dayNumber + 1;
    
    console.log(`[ONBOARDING] Incrementing day from ${dayNumber} to ${nextDay}`);
    localStorage.setItem('onboarding-day-number', nextDay.toString());
    
    return nextDay;
  } catch (error) {
    console.error('Error incrementing day number:', error);
    return 1;
  }
};
